import { useEffect, useState } from "react";
import { Stage, Layer, Image as KImage } from "react-konva";
import axios from "axios";
import { useLanguage } from '@/lib/i18n';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;


// IMAGE HOOK
function useImage(url) {
    const [img, setImg] = useState(null);

    useEffect(() => {
        if (!url) return;

        const image = new window.Image();
        image.src = url;
        image.crossOrigin = "anonymous";
        image.onload = () => setImg(image);

    }, [url]);

    return img;
}


// SIGNATURE
function Signature({ sig }) {
    const img = useImage(sig.assetUrl);

    if (!img) return null;

    return (
        <KImage
            image={img}
            x={sig.x}
            y={sig.y}
            width={sig.width}
            height={sig.height}
        />
    );
}


// PAGE
export default function Izbirak() {
    const { t } = useLanguage();

    const [signatures, setSignatures] = useState([]);

    useEffect(() => {
        axios
            .get(`${API}/wall/main/signatures`)
            .then(res => setSignatures(res.data));
    }, []);

    return (
        <main className="pt-32 pb-24 min-h-screen">

            <div className="max-w-7xl mx-auto px-6">

                <h1 className="text-4xl font-bold mb-8">
                    {t("izbirak_title")}
                </h1>

                <div className="border border-white/10 overflow-auto bg-white">

                    <Stage width={1000} height={1000}>
                        <Layer>

                            {signatures.map(sig => (
                                <Signature key={sig.id} sig={sig} />
                            ))}

                        </Layer>
                    </Stage>

                </div>

            </div>

        </main>
    );
}
